import React from 'react';
import { Link } from '@reach/router';
import NavLink from 'shared/NavLink';
import LogoSVG from 'images/fstatus-logo.svg';
import { Tooltip } from 'freemium-ui';
import Downshift from 'downshift';

import Icon, { CustomIcons } from '../Icons';

import { StyledAppSidebar, StyleDropdown } from './style';

const helpInfoUrls = [
  {
    label: 'FAQ',
    href: 'https://support.freshstatus.io/support/solutions'
  },
  {
    label: 'Contact us',
    href: 'https://support.freshstatus.io/support/tickets/new'
  },
  {
    label: 'Privacy policy',
    href: 'https://www.freshworks.com/privacy/'
  }
];

type GlobalSideNavProps = {
  uri: string,
  user: any
};

const GlobalSideNav = ({ uri, user }: GlobalSideNavProps) => {
  
  const isAdmin = user && (user.role === 'OW' || user.role === 'AD');

  return (
    <StyledAppSidebar className="App-sidebar">
      <div className="brand">
        <Link to={`${uri}`}>
          <img src={LogoSVG} alt="Freshstatus Logo" />
        </Link>
      </div>
      <div className="sidebar">
        <ul className="sidebar_top">
          <li>
            <Tooltip
              label="Incidents and maintenance"
              position="right"
              interactive={false}
            >
              <NavLink
                to={`${uri}/incidents/public`}
                activeMatch={`${uri}/incidents`}
              >
                {/* {CustomIcons('incident')} */}
                <Icon glyph="incidents" size={22} viewBox="0 0 22 22" />
              </NavLink>
            </Tooltip>
          </li>
          {isAdmin ? (
            <>
              <li>
                <Tooltip
                  label="Service components"
                  position="right"
                  interactive={false}
                >
                  <NavLink
                    to={`${uri}/service-customize`}
                    activeMatch={`${uri}/service-customize`}
                  >
                    <Icon
                      glyph="shape"
                      size={22}
                      viewBox="0 0 22 22"
                      fill="none"
                    />
                  </NavLink>
                </Tooltip>
              </li>
              <li>
                <Tooltip
                  label="Status page customization"
                  position="right"
                  interactive={false}
                >
                  <NavLink
                    to={`${uri}/status-customize`}
                    activeMatch={`${uri}/status-customize`}
                  >
                    {CustomIcons('customize')}
                  </NavLink>
                </Tooltip>
              </li>
            </>
          ) : null}
          <li>
            <Tooltip label="Status embed" position="right" interactive={false}>
              <NavLink
                to={`${uri}/status-embed`}
                activeMatch={`${uri}/status-embed`}
              >
                {CustomIcons('status-embed')}
              </NavLink>
            </Tooltip>
          </li>
          <li>
            <Tooltip label="Reports" position="right" interactive={false}>
              <NavLink
                to={`${uri}/reports/incident`}
                activeMatch={`${uri}/reports`}
              >
                {CustomIcons('reports')}
              </NavLink>
            </Tooltip>
          </li>
          {isAdmin ? (
            <li>
              <Tooltip label="Settings" position="right" interactive={false}>
                <NavLink to={`${uri}/settings`} activeMatch={`${uri}/settings`}>
                  {CustomIcons('settings')}
                </NavLink>
              </Tooltip>
            </li>
          ) : null}
          <li>
            <Tooltip label="Explore" position="right" interactive={false}>
              <NavLink to={`${uri}/explore`} activeMatch={`${uri}/explore`}>
                {CustomIcons('explore')}
              </NavLink>
            </Tooltip>
          </li>
        </ul>
        <ul className="sidebar_bottom">
          {/* <li>
            <NavLink to={`${uri}/settings`}>
            </NavLink>
          </li> */}
          <li className="helpIcon">
            <StyleDropdown>
              <Downshift>
                {({ getItemProps, isOpen, toggleMenu }) => (
                  <div style={{ position: 'relative' }}>
                    <div className="infoLogo-wrapper" onMouseEnter={toggleMenu}>
                      <Icon label="help" glyph="help" size="20" />
                    </div>
                    <div>
                      <div
                        className={`dropdown droplist-menu ${isOpen &&
                          'dropdown-menu--open'}`}
                        onMouseLeave={toggleMenu}
                      >
                        {helpInfoUrls.map(item => (
                          <a
                            {...getItemProps({ item })}
                            key={item.label}
                            className="dropdown__item"
                            style={{ cursor: 'pointer' }}
                            href={item.href}
                            rel="noreferrer noopener"
                            target="_blank"
                          >
                            {item.label}
                          </a>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
              </Downshift>
            </StyleDropdown>
          </li>
        </ul>
      </div>
    </StyledAppSidebar>
  );
};

export default GlobalSideNav;
